import DashboardRedemptionAnalytics from "./DashboardRedemptionAnalytics";

export default DashboardRedemptionAnalytics;
